import React, { useState, useEffect } from 'react';
import { playThemeSound } from '../../../utils/themeAudio';

const SNOW_ITEMS = ['❄️', '⚪', '✨', '⭐', '❄️'];
const CATCH_PHRASES = ['CRAZY CHILL! ❄️', 'HOLIDAY MAGIC! ✨', 'SNOWBALL! ⛄', 'CHILL VIBES! 🌨️'];

const InteractiveSnow = () => {
    const [snowflakes, setSnowflakes] = useState([]);
    const [catches, setCatches] = useState([]);

    useEffect(() => {
        const initial = Array.from({ length: 28 }).map((_, i) => ({
            id: i,
            content: SNOW_ITEMS[Math.floor(Math.random() * SNOW_ITEMS.length)],
            left: Math.random() * 98,
            delay: Math.random() * 6,
            duration: 6 + Math.random() * 8,
            size: 14 + Math.random() * 16,
            opacity: 0.5 + Math.random() * 0.45,
            caught: false
        }));
        setSnowflakes(initial);
    }, []);

    const handleCatch = (flake, e) => {
        e.stopPropagation();
        playThemeSound('christmas', 'sparkle');

        const rect = e.currentTarget.getBoundingClientRect();
        const effectId = Date.now() + Math.random();
        const text = CATCH_PHRASES[Math.floor(Math.random() * CATCH_PHRASES.length)];

        setCatches(prev => [...prev, {
            id: effectId,
            x: rect.left,
            y: rect.top,
            text
        }]);

        setTimeout(() => {
            setCatches(prev => prev.filter(item => item.id !== effectId));
        }, 1100);

        setSnowflakes(prev => prev.map(item => {
            if (item.id === flake.id) return { ...item, caught: true };
            return item;
        }));

        setTimeout(() => {
            setSnowflakes(prev => prev.map(item => {
                if (item.id === flake.id) {
                    return {
                        ...item,
                        caught: false,
                        left: Math.random() * 98,
                        delay: 0,
                        duration: 6 + Math.random() * 8
                    };
                }
                return item;
            }));
        }, 2500);
    };

    return (
        <div className="fixed inset-0 pointer-events-none z-[61] overflow-hidden select-none">
            {/* Catch Pop-up text */}
            {catches.map((eff) => (
                <div
                    key={eff.id}
                    className="fixed text-xs md:text-sm font-extrabold text-cyan-300 drop-shadow-[0_2px_8px_rgba(56,189,248,0.9)] animate-float-up pointer-events-none z-[75]"
                    style={{ left: eff.x, top: eff.y }}
                >
                    {eff.text}
                </div>
            ))}

            {/* Falling Snowflakes */}
            {snowflakes.map((f) => {
                if (f.caught) return null;
                return (
                    <div
                        key={f.id}
                        onClick={(e) => handleCatch(f, e)}
                        onTouchStart={(e) => handleCatch(f, e)}
                        className="absolute top-[-30px] animate-snow pointer-events-auto cursor-pointer hover:scale-140 transition-transform"
                        style={{
                            left: `${f.left}%`,
                            fontSize: `${f.size}px`,
                            opacity: f.opacity,
                            animationDelay: `${f.delay}s`,
                            animationDuration: `${f.duration}s`,
                            filter: 'drop-shadow(0 0 6px rgba(255, 255, 255, 0.7))'
                        }}
                        title="Click to catch the snowflake!"
                    >
                        {f.content}
                    </div>
                );
            })}

            {/* Bottom Frost Drift */}
            <div className="fixed bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-sky-950/40 via-sky-900/10 to-transparent pointer-events-none z-[25]" />
        </div>
    );
};

export default InteractiveSnow;
